import { peopleReflow, peopleFilter } from '../people';

export default {
  init() {
  },
  finalize() {
    // JavaScript to be fired on the people page, after the init JS
    // window.peopleGridState = jQuery('#people-grid').clone();

    peopleReflow();
    peopleFilter();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/people.js